import metadata from 'src/constants/metadata';

interface EventJsonLdCProps {
	article: any;
}

const EventJsonLdC = (props: EventJsonLdCProps) => {
	const { article } = props;

	const EventOnline = {
		'@context': 'https://schema.org',
		'@type': 'Event',
		name: article.title,
		startDate: article.start_date,
		endDate: article.end_date,
		eventAttendanceMode: 'https://schema.org/OnlineEventAttendanceMode',
		eventStatus: 'https://schema.org/EventScheduled',
		location: {
			'@type': 'VirtualLocation',
			url: article.ur_link,
		},
		image: article.image_files[0].path,
		description: article.description,
		offers: {
			'@type': 'Offer',
			url: metadata.WEB_URL + '/event/' + article.uid,
			price: '0',
			priceCurrency: 'IDR',
			availability: 'https://schema.org/InStock',
			validFrom: article.publish_date,
		},
		organizer: {
			'@type': 'Organization',
			name: 'HalloBumil',
			url: metadata.WEB_URL,
		},
	};

	const EventOffline = {
		'@context': 'https://schema.org',
		'@type': 'Event',
		name: article.title,
		startDate: article.start_date,
		endDate: article.end_date,
		eventAttendanceMode: 'https://schema.org/OfflineEventAttendanceMode',
		eventStatus: 'https://schema.org/EventScheduled',
		location: {
			'@type': 'Place',
			name: article.address,
			address: {
				'@type': 'PostalAddress',
				streetAddress: article.address,
				addressLocality: article.address,
				postalCode: '0',
				addressCountry: 'ID',
			},
		},
		image: article.image_files[0].path,
		description: article.description,
		offers: {
			'@type': 'Offer',
			url: metadata.WEB_URL + '/event/' + article.uid,
			price: '0',
			priceCurrency: 'IDR',
			availability: 'https://schema.org/InStock',
			validFrom: article.publish_date,
		},
		organizer: {
			'@type': 'Organization',
			name: 'HalloBumil',
			url: metadata.WEB_URL,
		},
	};

	return (
		<>
			{article.address.length > 0 ? (
				<script
					defer
					id="EventOnline"
					type="application/ld+json"
					dangerouslySetInnerHTML={{ __html: JSON.stringify(EventOffline) }}
				/>
			) : (
				<script
					defer
					id="EventOnline"
					type="application/ld+json"
					dangerouslySetInnerHTML={{ __html: JSON.stringify(EventOnline) }}
				/>
			)}
		</>
	);
};

export default EventJsonLdC;
